import React, { useState } from 'react';
import { Form, Button, Col } from 'react-bootstrap';
import { ArrowRight } from 'lucide-react';
import TextBox from "../../Shared/common/components/Shared_FormControls/TextBox/TextBox";
import NumberFormat from "../../Shared/common/components/Shared_FormControls/Number/Number";
import Phone from "../../Shared/common/components/Shared_FormControls/PhoneNumberField/PhoneNumberField";
import Number from '../../Shared/common/components/Shared_FormControls/Number/Number';
import Website from '../../Shared/common/components/Shared_FormControls/Website/Website';

const DealershipInfoS1 = (props) => {

    const [validated, setValidated] = useState(false);
    const submit = (event) => {

        event.preventDefault();
        event.stopPropagation();
        setValidated(true);

        const form = event.currentTarget;

        if (form.checkValidity() !== false) {

            props.submitForm(event);

        }

    }

    const AdditionalField =(item)=>{
        let newFields = { ...item, onChange: (key, value) => props?.twoWayBind(key, value) }
        return <TextBox {...newFields} />          
    }

    return (
        <React.Fragment>

            <Form noValidate
                validated={validated}
                onSubmit={(event) => submit(event)}
                className="text-left from-wrapper">
                <div className='onboarding-form-box-modal'>
                    <h1 className="mb-4">Dealership Info</h1>
                    <p className='secondary-text-color mb-4'>Step 1/3 : Dealership Details</p>
                    <Form.Row className='two-fields-row mx-0'>
                        <Form.Group controlId="formBasicFN">
                            <TextBox
                                required
                                label="Number of Locations"
                                name="Number of Locations"
                                value={props.formData.numberOfLocations}
                                objectKey="numberOfLocations"
                                placeholder="ex: 123"
                                onChange={(key, value) => props.twoWayBind(key, value)}
                            />
                            {/* <Form.Label className="label-color dealership minHeightMobile-48px">Number of Locations</Form.Label>
                        <Form.Control
                            required
                            type="text"
                            name="numberoflocations"
                            placeholder="ex: 123"
                            value={props.formData.numberOfLocations}
                            className="content-text-13px"
                            onChange={(event) => props.twoWayBind('numberOfLocations', event.target.value)}
                        />
                        <Form.Control.Feedback type="invalid">
                            Please enter Number of Locations.
                        </Form.Control.Feedback> */}
                        </Form.Group>
                        <Form.Group controlId="formBasicLN">
                            <TextBox
                                required
                                label="Average Number Of Units Sold Per Month"
                                name="Average Number Of Units Sold Per Month"
                                value={props.formData.avgUnitsSoldPerMonth}
                                objectKey="avgUnitsSoldPerMonth"
                                placeholder="ex: 123"
                                onChange={(key, value) => props.twoWayBind(key, value)}
                            />
                            {/* <Form.Label className="label-color">Average Number Of Units Sold Per Month</Form.Label>
                        <Form.Control
                            required
                            type="text"
                            name="unitssold"
                            value={props.formData.avgUnitsSoldPerMonth}
                            className="content-text-13px"
                            placeholder="ex: 123"
                            onChange={(event) => props.twoWayBind('avgUnitsSoldPerMonth', event.target.value)}
                        />
                        <Form.Control.Feedback type="invalid">
                            Please enter average number of units sold.
                        </Form.Control.Feedback> */}
                        </Form.Group>
                        <Form.Group controlId="formBasicDN">
                            <TextBox
                                required
                                label="Average Inventory Age (Days)"
                                name="Average Inventory Age (Days)"
                                value={props.formData.avgInventoryAge}
                                objectKey="avgInventoryAge"
                                placeholder="ex: 123"
                                onChange={(key, value) => props.twoWayBind(key, value)}
                            />
                            {/* <Form.Label className="label-color">Average Inventory Age (Days)</Form.Label>
                        <Form.Control
                            required
                            type="text"
                            name="avgInventoryAge"
                            value={props.formData.avgInventoryAge}
                            className="content-text-13px"
                            placeholder="ex: 123"
                            onChange={(event) => props.twoWayBind('avgInventoryAge', event.target.value)}
                        />
                        <Form.Control.Feedback type="invalid">
                            Please enter average inventory age.
                        </Form.Control.Feedback> */}
                        </Form.Group>
                        <Form.Group controlId="formBasicDN">
                            <NumberFormat
                                required
                                decimalScale={2}
                                fixedDecimalScale
                                allowNegative={false}
                                name="Average Sale Price"
                                label="Average Sale Price"
                                prefix='$'
                                thousandSeparator={true}
                                value={props.formData.avgSalePrice}
                                objectKey="avgSalePrice"
                                placeholder="ex: 123"
                                onChange={(key, value) => props.twoWayBind(key, value)}
                            />
                            {/* <Form.Label className="label-color">Average Sale Price</Form.Label>
                        <Form.Control
                            required
                            type="text"
                            name="avgSalePrice"
                            value={props.formData.avgSalePrice}
                            className="content-text-13px"
                            placeholder="ex: 123"
                            onChange={(event) => props.twoWayBind('avgSalePrice', event.target.value)}
                        />
                        <Form.Control.Feedback type="invalid">
                            Please enter average sale price.
                        </Form.Control.Feedback> */}
                        </Form.Group>
                        <Form.Group controlId="formBasicDN">
                            <TextBox
                                required
                                label="Years in business?"
                                name="Years in business?"
                                value={props.formData.yearsInBusiness}
                                objectKey="yearsInBusiness"
                                placeholder="ex: 3"
                                onChange={(key, value) => props.twoWayBind(key, value)}
                            />
                            {/* <Form.Label className="label-color">Years in business?</Form.Label>
                        <Form.Control
                            required
                            type="text"
                            name="yearsInBusiness"
                            value={props.formData.yearsInBusiness}
                            className="content-text-13px"
                            placeholder="ex: 3"
                            onChange={(event) => props.twoWayBind('yearsInBusiness', event.target.value)}
                        />
                        <Form.Control.Feedback type="invalid">
                            Please enter years in business.
                        </Form.Control.Feedback> */}
                        </Form.Group>
                        <Form.Group controlId="formBasicDN">
                            <Website
                                label="Dealership Website"
                                name="Dealership Website"
                                value={props.formData.webAddress}
                                objectKey="webAddress"
                                placeholder="www.sample.com"
                                onChange={(key, value) => props.twoWayBind(key, value)}
                            />
                            {/* <Form.Label className="label-color">Dealership Website</Form.Label>
                        <Form.Control
                            type="text"
                            name="DealershipWebsite"
                            value={props.formData.webAddress}
                            className="content-text-13px"
                            placeholder="www.sample.com"
                            pattern="^((ftp|http|https):\/\/)?(www.)?(?!.*(ftp|http|https|www.))[a-zA-Z0-9_-]+(\.[a-zA-Z]+)+((\/)[\w#]+)*(\/\w+\?[a-zA-Z0-9_]+=\w+(&[a-zA-Z0-9_]+=\w+)*)?$"
                            onChange={(event) => props.twoWayBind('webAddress', event.target.value ? event.target.value.trim() : event.target.value)}
                        />
                        <Form.Control.Feedback type="invalid">
                            Please enter Dealership Website.
                        </Form.Control.Feedback> */}
                        </Form.Group>
                        <Form.Group controlId="formBasicDN">
                            <Number
                                allowLeadingZeros
                                label="Auction Access Number (5 Million Number)"
                                name="Auction Access Number"
                                objectKey="auctionAccessNumber"
                                placeholder="Auction Access Number"
                                value={props.formData.auctionAccessNumber}
                                onChange={(key, value) => props.twoWayBind(key, value)}
                            />
                            {/* <Form.Label className="label-color">Auction Access Number (5 Million Number)</Form.Label>
                        <Form.Control
                            required
                            type="number"
                            name="auctionAccessNumber"
                            placeholder="Ex:5094957"
                            className="content-text-13px"
                            value={props.formData.auctionAccessNumber}
                            onChange={(event) => props.twoWayBind('auctionAccessNumber', event.target.value)}
                        />
                        <Form.Control.Feedback type="invalid">
                            Please enter Auction Access Number.
                        </Form.Control.Feedback> */}
                        </Form.Group>
                    </Form.Row>
                    {
                        props.formData?.referralInformation?.length ? 
                        <>
                            <b className='d-block mb-3'> Additional Information </b>
                            <Form.Row className='two-fields-row'>
                            { props.formData?.referralInformation.map(item => (
                                <Form.Group key={item.id}> { AdditionalField(item) } </Form.Group>
                            ))}
                            </Form.Row>
                        </> 
                        : null
                    }
                </div>
                <div>
                    <Button onClick={(event) => props.submitForm(event, true)} type="button" variant="outline-secondary" className="default-btn">Previous</Button>
                    <Button className="ml-3 default-btn" type="submit" variant="primary">Next</Button>
                </div>
            </Form>
        </React.Fragment>
    );

}

export default DealershipInfoS1;